// file: frontend/src/components/pages/admin/personas/DeletePersonaModal.jsx
import React from "react";
import { Loader2, AlertTriangle } from "lucide-react";

const DeletePersonaModal = ({ isOpen, onClose, onConfirm, persona, loading }) => {
  if (!isOpen || !persona) return null;

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-bg-60 rounded-xl shadow-lg p-6 w-full max-w-md relative">
        <button
          className="absolute top-2 right-2 text-fg-60 hover:text-fg-50 text-2xl"
          onClick={onClose}
          disabled={loading}
        >
          &times;
        </button>
        
        <div className="flex items-center gap-3 mb-4">
          <div className="flex-shrink-0">
            <AlertTriangle className="h-6 w-6 text-red-500" />
          </div>
          <h2 className="text-lg font-bold text-fg-100">Delete Persona</h2>
        </div>

        <div className="mb-6">
          <p className="text-fg-80 mb-2">
            Are you sure you want to delete the persona <strong>"{persona.name}"</strong>?
          </p>
          <p className="text-fg-60 text-sm">
            This action cannot be undone. All conversations using this persona will lose their persona context.
          </p>
        </div>

        <div className="flex justify-end gap-2">
          <button
            type="button"
            className="px-3 py-1.5 text-xs rounded bg-bg-50 text-fg-60 font-semibold hover:bg-bg-40 disabled:opacity-50"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="px-3 py-1.5 text-xs rounded bg-red-600 text-white dark:text-black font-semibold hover:bg-red-700 disabled:opacity-50 flex items-center gap-2"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading && <Loader2 className="animate-spin w-4 h-4" />}
            Delete Persona
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePersonaModal;